import { defineMessages } from 'react-intl';

export default defineMessages({
  noSearchResults: {
    id: 'widget.home-view.no-search-results',
    defaultMessage: 'No search results',
  },
  thisChannelIsComingSoon: {
    id: 'widget.this-channel-is-coming-soon',
    defaultMessage: 'This channel is coming soon!',
  },
});



// WEBPACK FOOTER //
// ./src/widget/translations/index.js